<script>
import Layout from "@layouts/form";
import Expediente from "@forms/Expediente";

export default {
  page: {
    title: "Detalhes | Expediente"
  },
  components: { Layout, Expediente },
  props: {
    editable: {
      type: Boolean,
      default: false
    },
    copy: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      title: "Expediente",
      items: [
        {
          text: "Página inicial",
          href: "/"
        },
        {
          text: "Expediente",
          href: "/Atendimentos"
        },
        {
          text: this.copy ? "Copiar" : "Edição",
          active: true
        }
      ]
    };
  }
};
</script>

<template>
  <Layout :title="title" :items="items">
    <div class="page-content">
      <Expediente :editable="editable" :copy="copy" />
    </div>
  </Layout>
</template>
